import { render, staticRenderFns } from "./ContactsSuccess.vue?vue&type=template&id=6f0897c6"
import script from "./ContactsSuccess.vue?vue&type=script&lang=js"
export * from "./ContactsSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports